import { MprcConfirmDialog, MprcRequestIndicator } from "components";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    deployId: string;
    title: string;
    onClose: (reload?: boolean) => void;
}

export const AssDeployDeclineDialog = ({ deployId, title, onClose }: IProps) => {
    const api = useCoreApi();
    const { t } = useTranslation("assessment");
    const [posting, setPosting] = useState<boolean>(false);

    const doDecline = () => {
        return new Promise((resolve, reject) => {
            api.v1.assDeploy.declineAdHocSurvey({deployId})
                .then(() => onClose(true))
                .catch(MprcRequestSnackbarErrorReport)
                .finally(() => setPosting(false));
        });
    };

    useEffect(() => {
        if (posting) doDecline();
    }, []);

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <MprcRequestIndicator type="post" visible={posting} />

            <MprcConfirmDialog
                open
                message={<>{t("AssDeploy.DeclineDialog.Message")} <b>{title}</b>?</>}
                onClose={
                    (confirm) => {
                        if (confirm) setPosting(true);
                        else onClose();
                    }
                }
            />
        </>
    );
};
